import { PersistentStoreName } from 'stores/_utils/persistentStore/persistenceStoresCleanUpMap'
import { persistentInit } from 'stores/_utils/persistentStore/persistentStore'

export type TIntercomStore = {
  unreadMessagesCount: number
}

export const intercomStore = persistentInit<TIntercomStore>({
  initialState: { unreadMessagesCount: 0 },
  keysToPutInPersistentStorage: { unreadMessagesCount: true },
  keysToPutInURL: { unreadMessagesCount: false },
  storeName: PersistentStoreName.INTERCOM_STORE,
})
